'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.eligibilityModuleContent = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Sanitizer = require('acq-components/lib/base-components/Sanitizer/Sanitizer');

var _svgFetcher = require('acq-components/lib/utils/svgFetcher');

var _svgFetcher2 = _interopRequireDefault(_svgFetcher);

var _BulletListItem = require('acq-components/lib/base-components/BulletListItem/BulletListItem');

var _componentHelpers = require('../component-helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var eligibilityModuleContent = exports.eligibilityModuleContent = function eligibilityModuleContent(props) {
  var styles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var headerComponent = arguments[2];

  var content = props.contentArray || [];

  if (!content.length) return [];

  var eligibilityContent = [{
    children: _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(_Sanitizer.Sanitizer, {
        safelySetInnerHTML: props.title,
        Component: headerComponent
      }),
      _react2.default.createElement(_Sanitizer.Sanitizer, { safelySetInnerHTML: props.description, Component: 'p' })
    ),
    key: 0,
    styles: styles.redeemingBenefitItem
  }, {
    children: _react2.default.createElement(
      'div',
      null,
      content.slice(0, Math.ceil(content.length / 2)).map(function (content, index) {
        return _react2.default.createElement(
          _BulletListItem.BulletListItem,
          {
            image: (0, _svgFetcher2.default)('checkmark', 'us-commercial', {
              className: 'blue-icon'
            }),
            styles: styles.accordionContentItem,
            key: index
          },
          _react2.default.createElement(_componentHelpers.DescParser, { descArray: content.desc, InnerTag: 'p' })
        );
      })
    ),
    key: 1,
    styles: styles.redeemingBenefitItem
  }, {
    children: _react2.default.createElement(
      'div',
      null,
      content.slice(Math.ceil(content.length / 2), content.length).map(function (content, index) {
        return _react2.default.createElement(
          _BulletListItem.BulletListItem,
          {
            image: (0, _svgFetcher2.default)('checkmark', 'us-commercial', {
              className: 'blue-icon'
            }),
            styles: styles.accordionContentItem,
            key: index
          },
          _react2.default.createElement(_componentHelpers.DescParser, { descArray: content.desc, InnerTag: 'p' })
        );
      })
    ),
    key: 2,
    styles: styles.redeemingBenefitItem
  }];

  return eligibilityContent;
};